<template>
  <div class="login-style" v-if="loginStatus === '1'">
    <div class="login-mask"></div>
    <div class="login-content" @keyup.13="login">
      <div class="login-panel">
        <div class="login-hero">
          <div class="brand-row">
            <div class="brand-copy">
              <div class="brand-tag">Case Manager</div>
              <h1>{{systemName}}</h1>
              <p>覆盖样本录入、导入、扫码与流转管理的一体化工作台</p>
            </div>
          </div>
          <div class="hero-visual">
            <img class="hero-graphic" src="../assets/123.gif" alt="illustration">
          </div>
          <div class="hero-footer">
            <span class="hero-chip">流程清晰</span>
            <span class="hero-chip">数据可追踪</span>
            <span class="hero-version">{{versionNumber}}</span>
          </div>
        </div>
        <div class="form-panel">
          <div class="form-head">
            <div class="form-badge">Secure Access</div>
            <div class="form-title">{{$t('login.login')}}</div>
          </div>
          <div class="field-label">账号</div>
          <Input
            v-model="userName"
            maxlength="17"
            :placeholder="$t('login.usernamePlaceholder')"
            class="login-input"
            type="text"
            size="large"
            @on-focus="cancelError"
            @on-blur="syncRememberedPassword" />
          <div class="field-label">密码</div>
          <Input
            v-model="password"
            maxlength="17"
            :placeholder="$t('login.passwordPlaceholder')"
            class="login-input"
            type="password"
            size="large"
            @on-focus="handlePasswordFocus">
          </Input>
          <div class="error-text" v-if="isShowError">
            <Icon type="md-close-circle" size="18" class="error-icon" />
            <span>{{errorText}}</span>
          </div>
          <div class="remember-row">
            <Checkbox v-model="isStore" @on-change="rememberPassword">{{$t('login.rememberPassword')}}</Checkbox>
          </div>
          <div class="login-btn">
            <Button type="primary" class="submit-btn" @click="login">{{$t('login.login')}}</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hexsha1 from '../../static/js/hex-sha1'
const REMEMBERED_PASSWORD_MASK = '********'
export default {
  name: 'login',
  data () {
    return {
      $vue: '',
      userId: '',
      isStore: false,
      userList: [],
      systemName: '', // 系统名称
      versionNumber: '', // 版本号
      loginStatus: '', // 是否显示登录页面
      userName: '',
      password: '',
      rememberedPasswordHash: '',
      errorText: '',
      isShowError: false
    }
  },
  methods: {
    // login登录
    async login () {
      if (this.validateInfo()) {
        // 加密密码
        let psd = ''
        if (this.rememberedPasswordHash && this.password === REMEMBERED_PASSWORD_MASK) {
          psd = this.rememberedPasswordHash
        } else {
          psd = this.encryptPassword(this.password)
        }
        let KeyData = 'njfy870084' + this.userName + ',froeasy,' + psd
        let params = new URLSearchParams()
        params.append('KeyData', KeyData)
        let suc = await this.$http.post(this.$vue.getData('LOGIN_URL'), params)
        if (suc.data.result === '1') {
          this.userName = suc.data.data.username
          try {
            window.HandleEvent('isLogin', '1')
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
          this.userId = suc.data.data.id
          // 登录成功将数据放到localStorage中
          localStorage.setItem('account', this.userName)
          localStorage.setItem('userName', this.userName)
          localStorage.setItem('password' + this.userName, psd)
          localStorage.setItem('userId' + this.userName, this.userId)
          localStorage.setItem('laboratoryId', suc.data.data.laboratoryId)
          this.$router.push({name: 'Index'})
        } else {
          this.errorText = this.$t('login.incorrectPasswordTip')
          this.password = ''
          this.isShowError = true
        }
      }
    },
    // 加密密码
    encryptPassword (psd) {
      return hexsha1.hex_sha1(psd)
    },
    // 选择技术员
    selectUser () {
      // 放入当前用户名
      localStorage.setItem('userName', this.userName)
      this.syncRememberedPassword()
    },
    // 记住密码
    rememberPassword () {
      localStorage.setItem('isStore' + this.userName, this.isStore)
      if (!this.isStore && this.userName) {
        localStorage.removeItem('password' + this.userName)
        this.rememberedPasswordHash = ''
        this.password = ''
      }
    },
    handlePasswordFocus () {
      this.cancelError()
      if (this.rememberedPasswordHash && this.password === REMEMBERED_PASSWORD_MASK) {
        this.password = ''
      }
    },
    // 回填记住密码数据
    syncRememberedPassword () {
      if (!this.userName) {
        this.isStore = false
        this.password = ''
        this.rememberedPasswordHash = ''
        return
      }
      localStorage.setItem('userName', this.userName)
      if (localStorage.getItem('isStore' + this.userName) === 'true') {
        this.isStore = true
        this.rememberedPasswordHash = localStorage.getItem('password' + this.userName) || ''
        this.password = this.rememberedPasswordHash ? REMEMBERED_PASSWORD_MASK : ''
      } else {
        this.isStore = false
        this.password = ''
        this.rememberedPasswordHash = ''
      }
    },
    // 获取用户列表
    async getUserNameList () {
      let suc = await this.$http.post(this.$vue.getData('GET_USER_NAME_LIST_URL'))
      if (suc.data.result === '1') {
        this.loginStatus = suc.data.data.loginStatus
        if (this.loginStatus === '1') {
          this.systemName = suc.data.data.systemName
          this.versionNumber = suc.data.data.versionNumber
          this.userList = suc.data.data.userNameList
        } else {
          try {
            window.HandleEvent('isLogin', '1')
          } catch (e) {
            console.log('请配合最新智能诊断系统使用')
          }
          localStorage.removeItem('userName')
          this.$router.push({name: 'Index'})
        }
      }
    },
    // 校验用户名、密码
    validateInfo () {
      if (this.userName === '') {
        this.errorText = this.$t('login.usernamePlaceholder')
        this.isShowError = true
        return false
      } else if (this.password === '') {
        this.errorText = this.$t('login.passwordPlaceholder')
        this.isShowError = true
        return false
      }
      return true
    },
    cancelError () {
      this.isShowError = false
    }
  },
  beforeMount () {
    this.$vue = this
    this.userName = localStorage.getItem('account')
    this.syncRememberedPassword()
    this.getUserNameList()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .login-style
    width 100%
    min-height 100vh
    position relative
    overflow hidden
    background url("../assets/wpc-bg.png")
    background-repeat no-repeat
    background-size cover
    background-position center
    display flex
    align-items center
    justify-content center
  .login-mask
    position absolute
    inset 0
    background linear-gradient(135deg, rgba(26, 115, 232, 0.82), rgba(63, 163, 255, 0.58))
  .login-content
    position relative
    z-index 1
    width 1120px
    max-width calc(100% - 48px)
  .login-panel
    display flex
    min-height 480px
    border-radius 28px
    overflow hidden
    box-shadow 0 24px 70px rgba(20, 90, 180, 0.24)
    background rgba(238, 247, 255, 0.94)
    backdrop-filter blur(10px)
  .login-hero
    width 56%
    padding 30px 42px 22px
    color #fff
    background linear-gradient(160deg, rgba(63, 163, 255, 0.96), rgba(26, 115, 232, 0.98))
    position relative
    display flex
    flex-direction column
    justify-content space-between
    text-align left
  .login-hero:before
    content ''
    position absolute
    width 420px
    height 420px
    right -120px
    top -160px
    border-radius 50%
    background rgba(255, 255, 255, 0.08)
  .login-hero:after
    content ''
    position absolute
    width 260px
    height 260px
    left -80px
    bottom -100px
    border-radius 50%
    background rgba(255, 255, 255, 0.06)
  .brand-row
    position relative
    z-index 1
    display flex
    align-items flex-start
    gap 0
    justify-content flex-start
  .brand-copy h1
    margin 6px 0 10px
    font-size 34px
    line-height 1.2
    color #fff
    text-align left
  .brand-copy p
    margin 0
    max-width 420px
    line-height 1.8
    color rgba(255, 255, 255, 0.78)
    font-size 15px
    text-align left
  .brand-tag
    display inline-flex
    align-items center
    padding 6px 12px
    border-radius 999px
    background rgba(255, 255, 255, 0.12)
    font-size 12px
    letter-spacing 1px
  .hero-visual
    position relative
    z-index 1
    text-align center
    padding 8px 0 4px
  .hero-graphic
    width 100%
    max-width 300px
    filter drop-shadow(0 18px 30px rgba(4, 20, 45, 0.28))
  .hero-footer
    position relative
    z-index 1
    display flex
    align-items center
    flex-wrap wrap
    gap 12px
    justify-content flex-start
  .hero-chip
    padding 8px 14px
    border-radius 999px
    background rgba(255, 255, 255, 0.12)
    color rgba(255, 255, 255, 0.9)
    font-size 13px
  .hero-version
    margin-left auto
    font-size 14px
    color rgba(255, 255, 255, 0.78)
  .form-panel
    width 44%
    padding 30px 46px 24px
    display flex
    flex-direction column
    justify-content flex-start
    text-align left
    position relative
    background linear-gradient(180deg, rgba(247, 251, 255, 0.98), rgba(233, 244, 255, 0.96))
  .form-panel:before
    content ''
    position absolute
    inset 0
    background linear-gradient(180deg, rgba(255, 255, 255, 0.34), rgba(63, 163, 255, 0.08))
    pointer-events none
  .form-head
    margin-bottom 14px
    margin-top 0
    position relative
    z-index 1
    text-align left
  .form-badge
    display inline-flex
    align-items center
    padding 6px 12px
    border-radius 999px
    margin-bottom 16px
    background rgba(63, 163, 255, 0.14)
    color #1a73e8
    font-size 12px
    font-weight 600
    letter-spacing 0.6px
  .form-title
    font-size 30px
    font-weight 600
    color #1a4f95
    line-height 1.2
  .form-subtitle
    margin-top 10px
    color #5c84b8
    font-size 14px
    text-align left
  .field-label
    margin 10px 0 6px
    font-size 13px
    color #3c6aa4
    font-weight 600
    letter-spacing 1px
    text-align left
  .login-input
    width 100%
    position relative
    z-index 1
  .login-input /deep/ .ivu-input-large
    height 48px
    border-radius 14px
    border 1px solid #b8d6fb
    background rgba(255, 255, 255, 0.92)
    font-size 15px
    padding 0 16px
  .login-input /deep/ .ivu-input-large:focus
    border-color #2d8cf0
    box-shadow 0 0 0 3px rgba(45, 140, 240, 0.14)
  .error-text
    display flex
    align-items center
    gap 8px
    margin-top 10px
    padding 10px 12px
    color #b74d46
    background-color #fff0f0
    border 1px solid #ffd2d2
    border-radius 12px
    line-height 20px
    font-size 12px
    position relative
    z-index 1
  .error-icon
    color #dc3c00
  .remember-row
    margin-top 10px
    color #4d75a8
    position relative
    z-index 1
    text-align left
  .remember-row /deep/ .ivu-checkbox-wrapper
    color #4d75a8
  .login-btn
    padding-top 14px
    position relative
    z-index 1
  .submit-btn
    width 100%
    height 48px
    font-size 16px
    border none
    border-radius 14px
    background linear-gradient(135deg, #3fa3ff, #1a73e8)
    box-shadow 0 16px 34px rgba(26, 115, 232, 0.26)
  .submit-btn:hover
    opacity 0.95
  @media (max-width: 1024px)
    .login-content
      max-width calc(100% - 32px)
    .login-panel
      min-height auto
    .login-hero
      width 50%
      padding 28px 28px 20px
    .form-panel
      width 50%
      padding 28px 28px 22px
  @media (max-width: 768px)
    .login-style
      align-items stretch
    .login-content
      width 100%
      max-width 100%
      padding 20px
    .login-panel
      flex-direction column
      border-radius 22px
    .login-hero
      width 100%
      padding 28px 24px
    .brand-copy h1
      font-size 26px
    .brand-copy p
      font-size 13px
    .hero-visual
      text-align center
      padding 12px 0 6px
    .hero-graphic
      width 100%
      max-width 280px
    .hero-version
      margin-left 0
    .form-panel
      width 100%
      padding 30px 24px 32px
</style>



// WEBPACK FOOTER //
// src/components/Login.vue